import { Card} from "@mui/material";
import { useEffect, useState } from "react";

export default function MainLayout(props) {
    const [currentScreen, setCurrentScreen] = useState(getWindowDimensions());
    const [currentScreenPx, setCurrentScreenPx] = useState('');

    function getWindowDimensions() {
        const { innerWidth: width } = window;
        return {
            width
        };
    }
    
    useEffect(() => {
        function handleResize() {
            setCurrentScreen(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setCurrentScreenPx((currentScreen.width - 150) + 'px')
    }, [currentScreen])

    return (
        <Card
            sx={{
                ml: '8px',
                mr: '8px',
                my: '30px',
                '& .css-1yijrg0-MuiCardContent-root': {
                    xs: {
                        width: currentScreenPx,
                        alignItems: 'center'
                    },
                    sm: {
                        width: currentScreenPx,
                        alignItems: 'center'
                    },
                    lg: {
                        width: 'auto',
                        alignItems: 'center'
                    },
                    xl: {
                        width: 'auto',
                        alignItems: 'center'
                    }
                }
            }}
        >
            <Card sx={{ p:2}}>
                {props.children}
            </Card>
        </Card>
    )
}